import React from "react";
import { usePublicSite } from "@/lib/utils-app";

export default function PublicPageHeader({ pageKey }) {
  const site = usePublicSite();
  const p = site[pageKey] || {};
  return (
    <>
      <div className="text-xs uppercase tracking-[0.3em] text-[#E63946]">{p.eyebrow}</div>
      <h1 className="font-display text-5xl md:text-7xl text-white mt-2">
        {p.title_prefix}{" "}
        <span className="text-[#FFD700]">{p.title_highlight}</span>
      </h1>
    </>
  );
}
